module.exports = __webpack_public_path__ + "img/small-logo.8d3ac022.png";